import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import NoRecruiterPositionsContainer from 'src/components/recruiterPositions/NoRecruiterPositionsContainer';
import RecruiterPositionsContainer from 'src/components/recruiterPositions/RecruiterPositionsContainer';
import Container from 'src/components/shared/Container';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPositionsForRecruiterQuery } from 'src/hooks/position.hooks';
import { sendTrackingEvent } from 'src/utils/gtm';
import { PositionStatus } from 'types';
import { Loader } from 'ui';

const RecruiterPositionsPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { isAccountManagerLoggedIn } = useUserContext();
	const { setPositions, setIsLoadingPositions, filterApplied } = useRecommendationsContext();

	const {
		data: positionsData,
		isLoading: isPositionsDataLoading,
		isError: isPositionsDataError,
	} = useGetPositionsForRecruiterQuery(isAccountManagerLoggedIn, '', data => setPositions(data.positions ?? []));

	const hasPositions = !filterApplied && !!positionsData?.positions?.length;

	const disableCreate = !!positionsData?.positions?.find(
		p =>
			!p?.position?.isPublished &&
			p.position.positionStatus === PositionStatus.OPEN &&
			dayjs().isBefore(p.position.expiresAt),
	);

	const handleCreatePosition = () => {
		sendTrackingEvent({
			event: 'recr_dashboard_postajob',
			eventLabel: location.pathname,
		});
		navigate('/create-position');
	};

	useEffect(() => {
		setIsLoadingPositions(isPositionsDataLoading);
	}, [isPositionsDataLoading]);

	if (isPositionsDataLoading) {
		return ( 
		// <Loader />
		<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
	);
	}

	if (isPositionsDataError || !positionsData?.positions) {
		// return error screen
		return null;
	}

	return (
		<>
			<Container>
				{hasPositions ? (
					<>
						<RecruiterPositionsContainer
							positionsData={positionsData.positions}
							handleCreatePosition={handleCreatePosition}
							disableCreate={disableCreate}
						/>
					</>
				) : (
					<>
						<div className="h-[calc(100vh-70px)] sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center">
							<NoRecruiterPositionsContainer onClick={handleCreatePosition} />
						</div>
					</>
				)}
			</Container>
		</>
	);
};

export default RecruiterPositionsPage;
